<template>
  <v-app class="page">
<!-- =====================================================
         MAIN
    ====================================================== -->

    <v-main>


      <!-- =================================================
           HERO
      ================================================== -->

      <section class="hero">

        <!-- Küchen-Hintergrund -->
        <v-img
          :src="kitchen"
          alt=""
          class="hero-background"
        />


        <!-- dunkle Überlagerung -->
        <div class="hero-overlay"></div>


        <div class="hero-inner">


          <!-- ===============================================
               PERSON
          ================================================ -->

          <div class="person-container">

            <v-img
              :src="Tom"
              alt="Thomas Schermuly"
              class="person-image"
            />

          </div>


          <!-- ===============================================
               HERO TEXT
          ================================================ -->

          <div class="hero-content">

            <div class="hero-eyebrow">
              HYGIENEDOZENT
            </div>


            <h1 class="hero-title">

              THOMAS

              <span>
                SCHERMULY
              </span>

            </h1>


            <p class="hero-description">
              Ihr Experte für Hygiene, Schulung und
              Lebensmittelsicherheit in der Praxis.
            </p>


            <div class="green-line"></div>


            <!-- HERO PUNKTE -->

            <div class="hero-points">


              <div class="hero-point">

                <v-icon>
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Dozent beim TÜV Saarland
                  und bei der Impuls Akademie
                </span>

              </div>


              <div class="hero-point">

                <v-icon>
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Internationaler
                  Qualitätsmanagement-Auditor
                </span>

              </div>


              <div class="hero-point">

                <v-icon>
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Autor für den Fachverlag Forum
                </span>

              </div>


              <div class="hero-point">

                <v-icon>
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Fachautor zu Großküchen-,
                  Lebensmittel- und
                  Krankenhaushygiene
                </span>

              </div>


            </div>

          </div>

        </div>

      </section>


      <!-- =================================================
           QUALIFIKATION
      ================================================== -->

      <section class="qualification-section">

        <div class="content-container">

          <div class="section-heading">

            <h2>
              QUALIFIKATION & KOMPETENZ
            </h2>

            <div class="heading-line"></div>

          </div>


          <div class="qualification-grid">


            <!-- FACHWISSEN -->

            <div class="qualification-card">

              <v-icon
                class="qualification-mdi-icon"
                size="48"
              >
                mdi-school-outline
              </v-icon>

              <img
                src="/images/qualification-fachwissen.png"
                alt=""
                class="qualification-icon qualification-icon-original"
              />

              <h3>
                FACHWISSEN
              </h3>

              <p>
                Fundiertes Fachwissen in
                Hygiene, Lebensmittelsicherheit
                und Qualitätsmanagement.
              </p>

            </div>


            <!-- DOZENT -->

            <div class="qualification-card">

              <v-icon
                class="qualification-mdi-icon"
                size="48"
              >
                mdi-human-male-board
              </v-icon>

              <img
                src="/images/qualification-dozent.png"
                alt=""
                class="qualification-icon qualification-icon-original"
              />

              <h3>
                DOZENTENTÄTIGKEIT
              </h3>

              <p>
                Erfahrene Schulungen und
                Seminare verständlich,
                praxisnah und aktuell.
              </p>

            </div>


            <!-- PRAXIS -->

            <div class="qualification-card">

              <v-icon
                class="qualification-mdi-icon"
                size="48"
              >
                mdi-shield-check-outline
              </v-icon>

              <img
                src="/images/qualification-praxis.png"
                alt=""
                class="qualification-icon qualification-icon-original"
              />

              <h3>
                PRAXISERFAHRUNG
              </h3>

              <p>
                Langjährige Erfahrung in der
                Lebensmittelbranche und in
                verschiedenen Einrichtungen.
              </p>

            </div>


            <!-- AUTOR -->

            <div class="qualification-card">

              <v-icon
                class="qualification-mdi-icon"
                size="48"
              >
                mdi-book-open-page-variant-outline
              </v-icon>

              <img
                src="/images/qualification-autor.png"
                alt=""
                class="qualification-icon qualification-icon-original"
              />

              <h3>
                AUTOR & FACHBEITRÄGE
              </h3>

              <p>
                Veröffentlichungen und
                Fachbeiträge zu Hygiene-
                themen und Standards.
              </p>

            </div>


            <!-- AUDITOR -->

            <div class="qualification-card">

              <v-icon
                class="qualification-mdi-icon"
                size="48"
              >
                mdi-earth
              </v-icon>

              <img
                src="/images/qualification-auditor.png"
                alt=""
                class="qualification-icon qualification-icon-original"
              />

              <h3>
                AUDITOR
              </h3>

              <p>
                Internationaler Qualitäts-
                management-Auditor
                mit systemischem Blick.
              </p>

            </div>


          </div>

        </div>

      </section>


      <!-- =================================================
           ÜBER MICH
      ================================================== -->

      <section
        id="ueber-mich"
        class="about-section"
      >

        <div class="content-container">

          <div class="section-heading">

            <h2>
              ÜBER MICH
            </h2>

            <div class="heading-line"></div>

          </div>


          <div class="about-grid">


            <div class="about-text">

              <p>
                Hygiene ist Vertrauen. Als Hygienedo­zent,
                Auditor und Fachautor unterstütze ich Unternehmen,
                Einrichtungen und Teams dabei, Hygiene nicht nur
                zu verstehen, sondern im Alltag sicher und
                erfolgreich umzusetzen.
              </p>


              <p>
                Mein Ziel ist es, komplexe Inhalte verständlich
                zu vermitteln und praxisorientierte Lösungen
                zu entwickeln, die wirklich wirken.
              </p>

            </div>


            <!-- ZITAT -->

            <div class="quote-box">

              <div class="quote-symbol">
                ”
              </div>

              <p>
                Praxiswissen aus Küche,
                Produktion und Schulung –
                für mehr Sicherheit,
                Qualität und Vertrauen.
              </p>


              <!-- Platzhalter für Signatur -->

              <v-img
                :src="sign"
                alt="Thomas Schermuly Unterschrift"
                class="signature-image"
              />

            </div>


          </div>

        </div>

      </section>


      <!-- =================================================
           SCHULUNGSTHEMEN
      ================================================== -->

      <section
        id="leistungen"
        class="topics-section"
      >

        <div class="content-container">

          <div class="section-heading">

            <h2>
              MEINE SCHULUNGSTHEMEN
            </h2>

            <div class="heading-line"></div>

          </div>


          <div class="topics-grid">


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-account-group-outline
              </v-icon>

              <img
                src="/images/topic-personalhygiene.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Personalhygiene
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-shield-check-outline
              </v-icon>

              <img
                src="/images/topic-haccp.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                HACCP
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-molecule
              </v-icon>

              <img
                src="/images/topic-allergene.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Allergene
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-thermometer
              </v-icon>

              <img
                src="/images/topic-temperatur.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Temperaturen
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-spray-bottle
              </v-icon>

              <img
                src="/images/topic-reinigung.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Reinigung &<br />
                Desinfektion
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-hand-wash
              </v-icon>

              <img
                src="/images/topic-hautschutz.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Hautschutz
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-alert-outline
              </v-icon>

              <img
                src="/images/topic-havarie.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Havariepläne
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-clipboard-check-outline
              </v-icon>

              <img
                src="/images/topic-eigenkontrolle.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Eigenkontrollsysteme
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-book-open-page-variant-outline
              </v-icon>

              <img
                src="/images/topic-ifsg.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                IfSG
              </span>

            </div>


            <div class="topic-card">

              <v-icon class="topic-mdi-icon" size="38">
                mdi-book-open-variant-outline
              </v-icon>

              <img
                src="/images/topic-lebensmittelrecht.png"
                alt=""
                class="topic-original-icon"
              />

              <span>
                Lebensmittelrecht
              </span>

            </div>


          </div>

        </div>

      </section>


      <!-- =================================================
           CTA
      ================================================== -->

      <section
        id="kontakt"
        class="cta-section"
      >

        <div class="cta-background"></div>


        <div class="content-container">

          <div class="cta-inner">


            <!-- Schild -->

            <div class="cta-icon">

              <v-icon
                class="cta-mdi-icon"
                size="72"
              >
                mdi-shield-check-outline
              </v-icon>

              <img
                src="/images/cta-shield.png"
                alt=""
                class="cta-original-icon"
              />

            </div>


            <!-- Text -->

            <div class="cta-text">

              <h2>
                BEREIT FÜR<br />
                MEHR
                <span>SICHERHEIT?</span>
              </h2>

              <p>
                Lassen Sie uns gemeinsam für Hygiene,
                Sicherheit und Rechtssicherheit sorgen.
              </p>

            </div>


            <!-- Button -->

            <a
              href="#kontakt"
              class="cta-button"
            >

              <span>
                Jetzt Beratung anfragen
              </span>

              <v-icon>
                mdi-arrow-right
              </v-icon>

            </a>


          </div>

        </div>

      </section>
</v-main>

  </v-app>
</template>


<script setup>
import Tom from '../assets/AvatarTom.png'
import sign from '../assets/signature.png'
import kitchen from '../assets/backgroundKitchen.png'
</script>

<style scoped>

/* ==========================================================
   GRUNDLAGEN
========================================================== */

:global(html) {
  scroll-behavior: smooth;
}

:global(body) {
  margin: 0;
  padding: 0;
  background: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  color: #111111;
}

:global(*) {
  box-sizing: border-box;
}

.page {
  background: #ffffff;
}

:root {
  --green: #78be20;
  --dark: #080808;
  --gray: #f4f4f4;
}


/* ==========================================================
   GEMEINSAMER CONTAINER
========================================================== */

.content-container {
  width: calc(100% - 136px);
  max-width: 1180px;
  margin: 0 auto;
}


/* ==========================================================
   HERO
========================================================== */

.hero {
  position: relative;

  width: 100%;

  height: 525px;

  overflow: hidden;

  background: #080808;

  color: #ffffff;
}


/* Küchenbild */

.hero-background {
  position: absolute;

  inset: 0;

  width: calc(100% + 180px);
  height: 100%;

  /*
     Das Küchenmotiv wird bewusst etwas nach rechts verschoben,
     damit links mehr ruhige schwarze Fläche entsteht –
     entsprechend der gewünschten Ruben-Vorlage.
  */
  object-fit: cover;
  object-position: right center;
  transform: translateX(180px);

  z-index: 0;
}


/* dunkle Überlagerung */

.hero-overlay {
  position: absolute;

  inset: 0;

  background:
    linear-gradient(
      90deg,
      rgba(5, 5, 5, 0.25) 0%,
      rgba(5, 5, 5, 0.08) 45%,
      rgba(5, 5, 5, 0.18) 100%
    );

  z-index: 1;
}


/* Hero Inhalt */

.hero-inner {
  position: relative;

  z-index: 2;

  width: 100%;

  max-width: 1180px;

  height: 525px;

  margin: 0 auto;

  display: grid;

  grid-template-columns: 60% 40%;
}


/* ==========================================================
   PERSON
========================================================== */

@media (min-width: 761px) {
  .person-container {
    grid-column: 2;
    grid-row: 1;
  }

  .hero-content {
    grid-column: 1;
    grid-row: 1;
  }
}

.person-container {
  position: relative;

  height: 525px;

  display: flex;

  align-items: flex-end;

  justify-content: center;

  overflow: hidden;
}


.person-image {
  position: absolute;

  bottom: 0;

  left: 0;

  width: 100%;

  height: 100%;

  object-fit: contain;

  object-position: bottom center;

  z-index: 3;
}


/* ==========================================================
   HERO TEXT
========================================================== */

.hero-content {
  padding-top: 68px;

  padding-left: 34px;

  padding-right: 30px;
}


.hero-content h1 {
  color: #ffffff;
}

.hero-content .hero-description {
  color: #ffffff;
}

.hero-content .hero-point span {
  color: #ffffff;
}


.hero-eyebrow {
  color: var(--green);

  font-size: 15px;

  font-weight: 600;

  margin-bottom: 12px;
}


.hero-title {
  margin: 0;

  padding: 0;

  font-size: 55px;

  line-height: 0.98;

  font-weight: 800;

  letter-spacing: 0.5px;

  color: #ffffff;
}


.hero-title span {
  display: block;

  color: var(--green);
}


.hero-description {
  margin-top: 22px;

  margin-bottom: 0;

  max-width: 490px;

  font-size: 16px;

  line-height: 1.75;

  color: #ffffff;
}


.green-line {
  width: 42px;

  height: 2px;

  background: var(--green);

  margin-top: 18px;

  margin-bottom: 22px;
}


.hero-points {
  display: grid;

  grid-template-columns: 1fr 1fr;

  column-gap: 32px;

  row-gap: 17px;

  max-width: 650px;
}


.hero-point {
  display: flex;

  align-items: flex-start;

  gap: 9px;

  font-size: 13px;

  line-height: 1.55;

  color: #ffffff;
}


.hero-point .v-icon {
  color: var(--green);

  font-size: 23px;

  flex-shrink: 0;
}


/* ==========================================================
   SECTIONS
========================================================== */

.section-heading {
  margin-bottom: 22px;
}

.section-heading h2 {
  margin: 0;

  font-size: 22px;

  line-height: 1.2;

  font-weight: 700;

  letter-spacing: 0.2px;

  color: #111111;
}


.heading-line {
  width: 43px;

  height: 2px;

  background: var(--green);

  margin-top: 10px;
}


/* ==========================================================
   QUALIFIKATION
========================================================== */

.qualification-section {
  background: #ffffff;

  color: #111111;

  padding-top: 38px;

  padding-bottom: 48px;
}


.qualification-grid {
  display: grid;

  grid-template-columns:
    repeat(5, 1fr);
}


.qualification-card {
  min-height: 145px;

  padding:
    0 20px;

  text-align: center;

  color: #111111;

  border-right:
    1px solid #e5e5e5;
}


.qualification-card:last-child {
  border-right: none;
}


/* MDI Icons für Qualifikation */

.qualification-mdi-icon {
  display: flex !important;

  align-items: center;

  justify-content: center;

  width: 52px;

  height: 52px;

  margin: 0 auto 10px;

  color: var(--green) !important;

  font-size: 48px !important;

  line-height: 1;

  opacity: 1;
}


/* Originalbilder bleiben im Code erhalten,
   die MDI Icons werden sichtbar verwendet. */

.qualification-icon-original {
  display: none;
}


.qualification-icon {
  width: 48px;

  height: 48px;

  object-fit: contain;

  margin-bottom: 10px;
}


.qualification-card h3 {
  margin:
    0 0 11px;

  font-size: 12px;

  font-weight: 700;

  color: #111111;
}


.qualification-card p {
  margin: 0;

  font-size: 11.5px;

  line-height: 1.65;

  color: #111111;
}


/* ==========================================================
   ÜBER MICH
========================================================== */

.about-section {
  background: #ffffff;

  color: #111111;

  padding-bottom: 40px;
}


.about-section .section-heading h2 {
  color: #111111;
}


.about-grid {
  display: grid;

  grid-template-columns:
    1.7fr 1fr;

  gap: 52px;

  align-items: center;
}


.about-text {
  padding-right: 15px;
}


.about-text p {
  margin:
    0 0 14px;

  font-size: 13px;

  line-height: 1.75;

  color: #111111;
}


.quote-box {
  min-height: 200px;

  padding:
    21px 28px 20px;

  background: #f3f3f3;

  color: #111111;
}


.quote-symbol {
  height: 35px;

  color: var(--green);

  font-size: 54px;

  line-height: 1;

  font-weight: 700;
}


.quote-box p {
  margin:
    0 0 13px 28px;

  font-size: 14px;

  line-height: 1.55;

  color: #111111;
}


.signature-image {
  display: block;

  width: 170px;

  height: auto;

  margin-left: 27px;
}


/* ==========================================================
   SCHULUNGSTHEMEN
========================================================== */

.topics-section {
  background: #ffffff;

  color: #111111;

  padding-bottom: 42px;
}


.topics-section .section-heading h2 {
  color: #111111;
}


.topics-grid {
  display: grid;

  grid-template-columns:
    repeat(5, 1fr);

  border-top:
    1px solid #eeeeee;
}


.topic-card {
  height: 105px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  gap: 9px;

  border-right:
    1px solid #eeeeee;

  border-bottom:
    1px solid #eeeeee;

  text-align: center;

  color: #111111;
}


.topic-card:nth-child(5n) {
  border-right: none;
}


/* MDI Icons für Schulungsthemen */

.topic-mdi-icon {
  display: flex !important;

  align-items: center;

  justify-content: center;

  width: 42px;

  height: 42px;

  color: var(--green) !important;

  font-size: 40px !important;

  line-height: 1;

  opacity: 1;
}


/* Originalbilder bleiben vollständig im Code erhalten */

.topic-original-icon {
  display: none;
}


.topic-card img {
  width: 38px;

  height: 38px;

  object-fit: contain;
}


.topic-card span {
  font-size: 11px;

  line-height: 1.3;

  color: #111111;
}


/* ==========================================================
   CTA
========================================================== */

.cta-section {
  position: relative;

  height: 130px;

  overflow: hidden;

  background: #080808;

  color: #ffffff;
}


.cta-background {
  position: absolute;

  inset: 0;

  background:
    linear-gradient(
      155deg,
      transparent 55%,
      rgba(120,190,32,0.08) 55.2%,
      transparent 55.5%
    );

  pointer-events: none;
}


.cta-inner {
  position: relative;

  height: 130px;

  display: flex;

  align-items: center;

  gap: 28px;
}


.cta-icon {
  width: 95px;

  display: flex;

  justify-content: center;
}


.cta-mdi-icon {
  color: var(--green) !important;
}


.cta-original-icon {
  display: none;
}


.cta-icon img {
  width: 72px;

  height: 72px;

  object-fit: contain;
}


.cta-text {
  flex: 1;

  color: #ffffff;
}


.cta-text h2 {
  margin: 0 0 7px;

  font-size: 23px;

  line-height: 1.15;

  font-weight: 700;

  color: #ffffff;
}


.cta-text h2 span {
  color: var(--green);
}


.cta-text p {
  margin: 0;

  font-size: 11px;

  line-height: 1.45;

  color: #ffffff;
}


.cta-button {
  min-width: 225px;

  height: 43px;

  padding:
    0 20px;

  background: var(--green);

  color: #000000;

  text-decoration: none;

  display: flex;

  align-items: center;

  justify-content: space-between;

  font-size: 12px;

  font-weight: 600;
}


.cta-button:hover {
  background: #8ed42c;
}


/* ==========================================================
   TABLET
========================================================== */

@media (max-width: 1000px) {

  .content-container,
  .hero-inner {
    width: calc(100% - 50px);
  }

  .hero-title {
    font-size: 45px;
  }


  .hero-content {
    padding-left: 20px;
  }


  .hero-point {
    font-size: 11.5px;
  }


  .qualification-card {
    padding: 0 12px;
  }

}


/* ==========================================================
   MOBILE
========================================================== */

@media (max-width: 760px) {

  .hero-background {
    width: calc(100% + 80px);
    transform: translateX(80px);
  }

  .person-container {
    grid-column: auto;
    grid-row: auto;
  }

  .hero-content {
    grid-column: auto;
    grid-row: auto;
  }


  .hero {
    height: auto;

    min-height: 850px;
  }


  .hero-inner {
    height: auto;

    min-height: 850px;

    width: 100%;

    display: flex;

    flex-direction: column;
  }


  .person-container {
    height: 390px;

    order: 1;
  }


  .hero-content {
    order: 2;

    padding:
      30px 25px 50px;
  }


  .hero-title {
    font-size: 42px;
  }


  .hero-points {
    grid-template-columns: 1fr;
  }


  .content-container {
    width: calc(100% - 40px);
  }


  .qualification-grid {
    grid-template-columns:
      1fr 1fr;

    gap: 25px 0;
  }


  .qualification-card {
    border-right: none;

    border-bottom:
      1px solid #eeeeee;

    padding-bottom: 20px;
  }


  .about-grid {
    grid-template-columns: 1fr;

    gap: 25px;
  }


  .topics-grid {
    grid-template-columns:
      1fr 1fr;
  }


  .topic-card:nth-child(5n) {
    border-right:
      1px solid #eeeeee;
  }


  .topic-card:nth-child(2n) {
    border-right: none;
  }


  .cta-section {
    height: auto;

    padding:
      30px 0;
  }


  .cta-inner {
    height: auto;

    flex-direction: column;

    align-items: flex-start;

    padding:
      10px 0;
  }


  .cta-button {
    width: 100%;
  }
}


/* ==========================================================
   KLEINE HANDYS
========================================================== */

@media (max-width: 450px) {

  .qualification-grid {
    grid-template-columns: 1fr;
  }


  .topics-grid {
    grid-template-columns:
      1fr 1fr;
  }


  .hero-title {
    font-size: 36px;
  }
}

</style>
